import Arrow from "Assets/svg/design/arrow.svg";
import Eraser from "Assets/svg/design/eraser.svg";
import VerticalConnection from "Assets/svg/design/couple_amodi.svg";
import HorizontalConnection from "Assets/svg/design/couple_ofoghi.svg";
import MullionVerticalManual from "Assets/svg/design/molion_amodi_manual.svg";
import MullionHorizontalManual from "Assets/svg/design/molion_ofoghi.svg";
import HorizontalDivision from "Assets/svg/design/taghsim_1_ofoghi.svg";
import HorizontalDivision3 from "Assets/svg/design/taghsim_3_ofoghi.svg";
import HorizontalDivision2 from "Assets/svg/design/taghsim_2_ofoghi.svg";
import VerticalDivision from "Assets/svg/design/taghsim_1_amodi.svg";
import VerticalDivision2 from "Assets/svg/design/taghsim_2_amodi.svg";
import VerticalDivision3 from "Assets/svg/design/taghsim_3_amodi.svg";
import MullionKatibe from "Assets/svg/design/m_k.svg";
import VerticalMullionKatibe from "Assets/svg/design/m_v.svg";
import GlobalVerticalMullion from "Assets/svg/design/mulion_amodi_sarasari.svg";
import GlobalHorizontalMullion from "Assets/svg/design/mulion_ofoghi_sarasari.svg";
import LeftWindow from "Assets/svg/design/pop_left_win.svg";
import RightWindow from "Assets/svg/design/pop_right_win.svg";
import LeftWindowTow from "Assets/svg/design/pop_2win_left.svg";
import RightWindowTow from "Assets/svg/design/pop_2win_right.svg";
import TopWindow from "Assets/svg/design/top_win.svg";
import BottomWindow from "Assets/svg/design/bot_win.svg";
import FolexVagonRight from "Assets/svg/design/folex_right.svg";
import FolexVagonLeft from "Assets/svg/design/folex_left.svg";
import FrenchLeftWindow from "Assets/svg/design/faransavi_left_1halateh.svg";
import FrenchRightWindow from "Assets/svg/design/faransavi_right_win.svg";
import FrenchRightWindowTow from "Assets/svg/design/faransavi_right_double_win.svg";
import FrenchLeftWindowTow from "Assets/svg/design/fransavi.svg";
import LeftDoor from "Assets/svg/design/door_left.svg";
import RightDoor from "Assets/svg/design/door_right.svg";
import LeftDoorTwo from "Assets/svg/design/pop_2win_left_door.svg";
import RightDoorTwo from "Assets/svg/design/pop_2win_right_door.svg";
import FrenchRightDoor from "Assets/svg/design/door_right_faransavi.svg";
import FrenchRightDoubleDoor from "Assets/svg/design/faransavi_right_double_win_door.svg";
import FrenchLeftDoor from "Assets/svg/design/door_left_faransavi.svg";
import FrenchLeftDoubleDoor from "Assets/svg/design/fransavi_left_double_door.svg";
import RightDrawerSingleRailTwo from "Assets/svg/design/tak_2_lengeh_1.svg";
import LeftDrawerSingleRailTwo from "Assets/svg/design/tak_2_lengeh_2.svg";
import LeftDrawerSingleRailThree from "Assets/svg/design/tak_3_lengeh_2.svg";
import RightDrawerSingleRailThree from "Assets/svg/design/tak_3_lengeh_1.svg";
import LeftDrawerSingleRailThreeLeaf from "Assets/svg/design/tak_3_lengeh_4.svg";
import RightDrawerSingleRailThreeLeaf from "Assets/svg/design/tak_3_lengeh_3.svg";
import RightAndLeftDrawerSingleRailThreeLeaf from "Assets/svg/design/tak_3_lengeh_5.svg";
import RightAndLeftDrawerSingleRailFourLeaf from "Assets/svg/design/tak_4_lengeh_2.svg";
import LeftAndRightDrawerSingleRailFourLeaf from "Assets/svg/design/tak_4_lengeh_1.svg";
import LeftDrawerSingleRailFourLeaf from "Assets/svg/design/tak_4_lengeh_4.svg";
import RightDrawerSingleRailFourLeaf from "Assets/svg/design/tak_4_lengeh_3.svg";
import LeftDrawerSingleRailFour from "Assets/svg/design/tak_4_lengeh_6.svg";
import RightDrawerSingleRailFour from "Assets/svg/design/tak_4_lengeh_5.svg";
import LeftDrawerFourLeatSingleRail from "Assets/svg/design/tak_4_lengeh_8.svg";
import RightDrawerFourLeatSingleRail from "Assets/svg/design/tak_4_lengeh_7.svg";
import RightAndRightDrawerSingleRailFourLeat from "Assets/svg/design/tak_4_lengeh_9.svg";
import LeftAndLeftDrawerSingleRailFourLeat from "Assets/svg/design/tak_4_lengeh_10.svg";
import RightAndLeftDrawerTwoRailTwoLeat from "Assets/svg/design/joft_2_lengeh_2.svg";
import LeftDrawerTwoRailTwoLeat from "Assets/svg/design/joft_2_lengeh_1.svg";
import RightDrawerTwoRailTwoLeat from "Assets/svg/design/joft_2_lengeh_3.svg";
import RightDrawerTwoRailThree from "Assets/svg/design/joft_3_lengeh_2.svg";
import LeftDrawerTwoRailThree from "Assets/svg/design/joft_3_lengeh_1.svg";
import RightDrawerTwoRailThreeLeat from "Assets/svg/design/joft_3_lengeh_4.svg";
import LeftDrawerTwoRailThreeLeat from "Assets/svg/design/joft_3_lengeh_3.svg";
import RightDrawerThreeLeatTwoRail from "Assets/svg/design/joft_3_lengeh_6.svg";
import LeftDrawerThreeLeatTwoRail from "Assets/svg/design/joft_3_lengeh_5.svg";
import RightDrawerThreeLeatTwoRails from "Assets/svg/design/joft_3_lengeh_8.svg";
import DrawerThreeLeatTwoRail from "Assets/svg/design/joft_3_lengeh_7.svg";
import RightAndLeftDrawerThreeLeatTwoRail from "Assets/svg/design/joft_3_lengeh_10.svg";
import RightAndLeftDrawerTwoRailThreeLeat from "Assets/svg/design/joft_3_lengeh_9.svg";
import RightAndRightLeftDrawerTwoRailThreeLeat from "Assets/svg/design/joft_3_lengeh_12.svg";
import RightAndLeftLeftDrawerTwoRailThreeLeat from "Assets/svg/design/joft_3_lengeh_11.svg";
import RightLeftDrawerTwoRailThreeLeat from "Assets/svg/design/joft_3_lengeh_13.svg";
import RightAndLeftDrawerTwoRailFourLeat from "Assets/svg/design/joft_4_lengeh_2.svg";
import LeftAndRightDrawerTwoRailFourLeat from "Assets/svg/design/joft_4_lengeh_1.svg";
import RightDrawerTwoRailFourLeat from "Assets/svg/design/joft_4_lengeh_4.svg";
import LeftDrawerTwoRailFourLeat from "Assets/svg/design/joft_4_lengeh_3.svg";
import RightDrawerFourLeatTwoRail from "Assets/svg/design/joft_4_lengeh_5.svg";
import LeftAndLeftDrawerTwoRailFourLeat from "Assets/svg/design/joft_4_lengeh_8.svg";
import RightAndLeftDrawerTwoRailFour from "Assets/svg/design/joft_4_lengeh_10.svg";
import RightAndLeftDrawerFourLeatTwoRail from "Assets/svg/design/joft_4_lengeh_9.svg";
import RightAndLeftRightDrawerTwoRailFourLeat from "Assets/svg/design/joft_4_lengeh_11.svg";
import LeftDrawerTwoRailFour from "Assets/svg/design/joft_4_lengeh_6.svg";
import RightAndRightDrawerTwoRailFourLeat from "Assets/svg/design/joft_4_lengeh_7.svg";
import Net from "Assets/svg/design/net.svg";
import Fix from "Assets/svg/design/fix.svg";
import LENGEH_RAIL_3_1RIGHT_2RIGHT_3FIX from "Assets/svg/design/LENGEH_RAIL_3_1RIGHT_2RIGHT_3FIX.svg";
import LENGEH_RAIL_3_3RIGHT_2RIGHT_1LEFT from "Assets/svg/design/LENGEH_RAIL_3_3RIGHT_2RIGHT_1LEFT.svg";
import LENGEH_RAIL_3_1RIGHT_2LEFT_3RIGHT_3RIGHT_2LEFT from "Assets/svg/design/LENGEH_RAIL_3_1RIGHT_2LEFT_3RIGHT_3RIGHT_2LEFT.svg";
import LENGEH_RAIL_3_1FIX_2LEFT_3RIGHT_3RIGHT_2FIX from "Assets/svg/design/LENGEH_RAIL_3_1FIX_2LEFT_3RIGHT_3RIGHT_2FIX.svg";
import LENGEH_RAIL_3_1FIX_2LEFT_3LEFT_3RIGHT_2RIGHT_1FIX from "Assets/svg/design/LENGEH_RAIL_3_1FIX_2LEFT_3LEFT_3RIGHT_2RIGHT_1FIX.svg";
import LENGEH_RAIL_3_3FIX_2LEFT_1LEFT_1RIGHT_2RIGHT_3FIX from "Assets/svg/design/LENGEH_RAIL_3_3FIX_2LEFT_1LEFT_1RIGHT_2RIGHT_3FIX.svg";
import LENGEH_RAIL_4_1FIX_2LEFT_3LEFT_4LEFT from "Assets/svg/design/LENGEH_RAIL_4_1FIX_2LEFT_3LEFT_4LEFT.svg";
import LENGEH_RAIL_4_1RIGHT_2RIGHT_3RIGHT_4FIX from "Assets/svg/design/LENGEH_RAIL_4_1RIGHT_2RIGHT_3RIGHT_4FIX.svg";
import LENGEH_RAIL_4_2FIX_1LEFT_1RIGHT_2RIGHT_3RIGHT_4FIX from "Assets/svg/design/LENGEH_RAIL_4_2FIX_1LEFT_1RIGHT_2RIGHT_3RIGHT_4FIX.svg";
import LENGEH_RAIL_4_4FIX_3LEFT_2LEFT_1LEFT_1RIGHT_2FIX from "Assets/svg/design/LENGEH_RAIL_4_4FIX_3LEFT_2LEFT_1LEFT_1RIGHT_2FIX.svg";
import LENGEH_RAIL_4_3FIX_2LEFT_1LEFT_1RIGHT_2RIGHT_3RIGHT_4FIX from "Assets/svg/design/LENGEH_RAIL_4_3FIX_2LEFT_1LEFT_1RIGHT_2RIGHT_3RIGHT_4FIX.svg";
import LENGEH_RAIL_4_4FIX_3LEFT_2LEFT_1LEFT_1RIGHT_2RIGHT_3FIX from "Assets/svg/design/LENGEH_RAIL_4_4FIX_3LEFT_2LEFT_1LEFT_1RIGHT_2RIGHT_3FIX.svg";
import LENGEH_RAIL_4_4FIX_3LEFT_2LEFT_1LEFT_1RIGHT_2RIGHT_3RIGHT_4FIX from "Assets/svg/design/LENGEH_RAIL_4_4FIX_3LEFT_2LEFT_1LEFT_1RIGHT_2RIGHT_3RIGHT_4FIX.svg";
import VerticalPanel from "Assets/svg/design/panel_amodi.svg";
import HorizontalPanel from "Assets/svg/design/panel_ofoghi.svg";
import Flashing from "Assets/svg/design/rokobIcon.svg";
import ak_2_0 from "Assets/svg/akardeoni/ak_2_0.svg";

/* Sys_tak_joft
0 ==> lolayi
1 ==> keshoyi tak reil keshoyi
2 ==> keshoyi joft rail
3 ==> tarkibi - lolayi & tak rail
4 ==> trkibi - lolayi & joft rail
5 ==> keshoyi 3 rail
6 ==> keshoyi 4 rail
7 ==> trkibi - lolayi & 3 rail
8 ==> trkibi - lolayi & 4 rail
* */

export default {
  general: [
    {
      title: "tool_side_drawer_Select", //"انتخاب",
      icon: Arrow,
      key: "SELECT",
      type: "general",
      auth: [0, 1, 2, 3, 4, 5, 6, 7, 8],
    },
    {
      title: "tool_side_drawer_Clear", //"پاک کن",
      icon: Eraser,
      key: "EraseMolion",
      type: "general",
      auth: [0, 1, 2, 3, 4, 5, 6, 7, 8],
    },
  ],
  division: [
    {
      title: "tool_side_drawer_Vertical_connection", //"اتصال عمودی",
      icon: VerticalConnection,
      key: "V_COUPLE",
      type: "division",
      auth: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      disabled: ["Id_profile_komaki"],
    },
    {
      title: "tool_side_drawer_Horizontal_connection", //"اتصال افقی",
      icon: HorizontalConnection,
      key: "H_COUPLE",
      type: "division",
      auth: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      disabled: ["Id_profile_komaki"],
    },
    {
      title: "tool_side_drawer_Vertical_mullion", //"مولیون عمودی",
      icon: MullionVerticalManual,
      key: "V_MOLION",
      type: "division",
      auth: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      disabled: ["Id_molion"],
    },
    {
      title: "tool_side_drawer_Horizontal_mullion", //"مولیون افقی",
      icon: MullionHorizontalManual,
      key: "H_MOLION",
      type: "division",
      auth: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      disabled: ["Id_molion"],
    },
    {
      title: "tool_side_drawer_Horizontal_divider", //"تقسیم کننده افقی",
      auth: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      disabled: ["Id_molion"],
      sub: [
        {
          title: "tool_side_drawer_Horizontal_divider", //"تقسیم کننده افقی",
          icon: HorizontalDivision,
          key: "DH1M",
          type: "division",
        },
        {
          title: "tool_side_drawer_Horizontal_divider", //"تقسیم کننده افقی",
          icon: HorizontalDivision2,
          key: "DH2M",
          type: "division",
        },
        {
          title: "tool_side_drawer_Horizontal_divider", //"تقسیم کننده افقی",
          icon: HorizontalDivision3,
          key: "DH3M",
          type: "division",
        },
      ],
    },
    {
      title: "tool_side_drawer_Vertical_divider", //"تقسیم کننده عمودی",
      auth: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      disabled: ["Id_molion"],
      sub: [
        {
          title: "tool_side_drawer_Vertical_divider", //"تقسیم کننده عمودی",
          icon: VerticalDivision,
          key: "DV1M",
          type: "division",
        },
        {
          title: "tool_side_drawer_Vertical_divider", //"تقسیم کننده عمودی",
          icon: VerticalDivision2,
          key: "DV2M",
          type: "division",
        },
        {
          title: "tool_side_drawer_Vertical_divider", //"تقسیم کننده عمودی",
          icon: VerticalDivision3,
          key: "DV3M",
          type: "division",
        },
      ],
    },
    {
      title: "tool_side_drawer_Full_mullion", //"مولیون سراسری",
      auth: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      disabled: ["Id_molion"],
      sub: [
        {
          title: "tool_side_drawer_Full_mullion", //"مولیون سراسری",
          icon: GlobalVerticalMullion,
          key: "V_MOLION_S",
          type: "division",
        },
        {
          title: "tool_side_drawer_Full_mullion", //"مولیون سراسری",
          icon: GlobalHorizontalMullion,
          key: "H_MOLION_S",
          type: "division",
        },
      ],
    },
    {
      title: "tool_side_drawer_Transom_mullion", //"مولیون کتیبه",
      auth: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      disabled: ["Id_mulion_katibeh"],
      sub: [
        {
          title: "tool_side_drawer_Transom_mullion", //"مولیون کتیبه",
          icon: MullionKatibe,
          key: "H_MOLION_Katibe",
          type: "division",
        },
        {
          title: "tool_side_drawer_Transom_mullion", //"مولیون کتیبه",
          icon: VerticalMullionKatibe,
          key: "V_MOLION_Katibe",
          type: "division",
        },
      ],
    },
  ],
  window: [
    // {
    //   title: "tool_side_drawer_Single_wl", //"در تک حالته چپ بازشو",
    //   icon: LeftWindow,
    //   key: "LEFT_POP_PIVOT",
    //   type: "window",
    //   name: "Pivot",
    //   auth: [0, 3, 4, 7, 8],
    //   disabled: ["Id_Sash_Out_Pivot"],
    // },
    // {
    //   title: "tool_side_drawer_Single_wl", //"در تک حالته چپ بازشو",
    //   icon: RightWindow,
    //   key: "RIGHT_POP_PIVOT_D",
    //   type: "window",
    //   name: "Pivot",
    //   auth: [0, 3, 4, 7, 8],
    //   disabled: ["Id_Sash_Out_Pivot"],
    // },
    {
      title: "tool_side_drawer_Single_wl", //"پنجره تک حالته چپ بازشو",
      icon: LeftWindow,
      key: "LEFT_POP",
      type: "window",
      name: "TakHalateh",
      auth: [0, 3, 4, 7, 8],
      disabled: ["Id_sash"],
    },
    {
      title: "tool_side_drawer_Single_wr", //"پنجره تک حالته راست بازشو",
      icon: RightWindow,
      key: "RIGHT_POP",
      type: "window",
      name: "TakHalateh",
      auth: [0, 3, 4, 7, 8],
      disabled: ["Id_sash"],
    },
    {
      title: "tool_side_drawer_Dual_wl", //"پنجره دو حالته چپ بازشو",
      icon: LeftWindowTow,
      key: "LEFT_UP_POP",
      type: "window",
      name: "TwoHalatteh",
      auth: [0, 3, 4, 7, 8],
      disabled: ["Id_sash"],
    },
    {
      title: "tool_side_drawer_Dual_wr", //"پنجره دو حالته راست بازشو",
      icon: RightWindowTow,
      key: "RIGHT_UP_POP",
      type: "window",
      name: "TwoHalatteh",
      auth: [0, 3, 4, 7, 8],
      disabled: ["Id_sash"],
    },
    {
      title: "tool_side_drawer_oTop", //"پنجره بالا بازشو",
      icon: TopWindow,
      key: "UP_POP",
      type: "window",
      name: "BalaBazsho",
      auth: [0, 3, 4, 7, 8],
      disabled: ["Id_sash"],
    },
    {
      title: "tool_side_drawer_oBottom", //"پنجره پایین بازشو",
      icon: BottomWindow,
      key: "DOWN_POP",
      type: "window",
      name: "PaeenBazsho",
      auth: [0, 3, 4, 7, 8],
      disabled: ["Id_sash"],
    },
    {
      title: "tool_side_drawer_Volkswagen", //"فولکس واگن",
      auth: [0, 3, 4, 7, 8],
      disabled: ["Id_sash"],
      sub: [
        {
          title: "tool_side_drawer_Volkswagen", //"فولکس واگن",
          icon: FolexVagonRight,
          key: "RIGHT_VAGON",
          type: "window",
          name: "FolexVagon",
        },
        {
          title: "tool_side_drawer_Volkswagen", //"فولکس واگن",
          icon: FolexVagonLeft,
          key: "LEFT_VAGON",
          type: "window",
          name: "FolexVagon",
        },
      ],
    },
    {
      title: "tool_side_drawer_French_window", //"پنجره فرانسوی",
      auth: [0, 3, 4, 7, 8],
      disabled: ["Id_sash"],
      disabled2: "Id_averhang",
      sub: [
        {
          title: "tool_side_drawer_French_window", //"پنجره فرانسوی",
          icon: FrenchLeftWindow,
          key: "F_LEFT",
          type: "window",
          name: "FaransaviChefti",
          name2: "FaransaviTakHalateh",
        },
        {
          title: "tool_side_drawer_French_window", //"پنجره فرانسوی",
          icon: FrenchRightWindow,
          key: "F_RIGHT",
          type: "window",
          name: "FaransaviChefti",
          name2: "FaransaviTakHalateh",
        },
        {
          title: "tool_side_drawer_French_window", //"پنجره فرانسوی",
          icon: FrenchRightWindowTow,
          key: "F_RIGHT_UP",
          type: "window",
          name: "FaransaviChefti",
          name2: "FaransaviTowHalateh",
        },
        {
          title: "tool_side_drawer_French_window", //"پنجره فرانسوی",
          icon: FrenchLeftWindowTow,
          key: "F_LEFT_UP",
          type: "window",
          name: "FaransaviChefti",
          name2: "FaransaviTowHalateh",
        },
      ],
    },
  ],
  door: [

    {
      title: "tool_side_drawer_Single_dl", //"در تک حالته چپ بازشو",
      icon: LeftDoor,
      key: "LEFT_POP_PIVOT_D",
      type: "door",
      name: "Pivot",
      auth: [0, 3, 4, 7, 8],
      disabled: ["Id_Sash_Door_Out_Pivot"],
    },
    {
      title: "tool_side_drawer_Single_dl", //"در تک حالته چپ بازشو",
      icon: RightDoor,
      key: "RIGHT_POP_PIVOT_D",
      type: "door",
      name: "Pivot",
      auth: [0, 3, 4, 7, 8],
      disabled: ["Id_Sash_Door_Out_Pivot"],
    },
    {
      title: "tool_side_drawer_Single_dl", //"در تک حالته چپ بازشو",
      icon: LeftDoor,
      key: "LEFT_POP_D",
      type: "door",
      name: "TakHalateh",
      auth: [0, 3, 4, 7, 8],
      disabled: ["Id_sash_door", "Id_sash_door_bazsho"],
    },
    {
      title: "tool_side_drawer_Single_dr", //"در تک حالته راست بازشو",
      icon: RightDoor,
      key: "RIGHT_POP_D",
      type: "door",
      name: "TakHalateh",
      auth: [0, 3, 4, 7, 8],
      disabled: ["Id_sash_door", "Id_sash_door_bazsho"],
    },
    {
      title: "tool_side_drawer_Dual_door", //"در دو حالته",
      auth: [0, 3, 4, 7, 8],
      disabled: ["Id_sash_door", "Id_sash_door_bazsho"],
      sub: [
        {
          title: "tool_side_drawer_Dual_door", //"در دو حالته",
          icon: LeftDoorTwo,
          key: "LEFT_UP_POP_D",
          type: "door",
          name: "TwoHalatteh",
        },
        {
          title: "tool_side_drawer_Dual_door", //"در دو حالته",
          icon: RightDoorTwo,
          key: "RIGHT_UP_POP_D",
          type: "door",
          name: "TwoHalatteh",
        },
      ],
    },
    {
      title: "tool_side_drawer_French_door", //"در فرانسوی",
      auth: [0, 3, 4, 7, 8],
      disabled: ["Id_sash_door", "Id_sash_door_bazsho"],
      disabled2: "Id_averhang",
      sub: [
        {
          title: "tool_side_drawer_French_door", //"در فرانسوی",
          icon: FrenchRightDoor,
          key: "F_RIGHT_D",
          type: "door",
          name2: "FaransaviChefti",
          name: "FaransaviTakHalateh",
        },
        {
          title: "tool_side_drawer_French_door", //"در فرانسوی",
          icon: FrenchLeftDoor,
          key: "F_LEFT_D",
          type: "door",
          name2: "FaransaviChefti",
          name: "FaransaviTakHalateh",
        },
        {
          title: "tool_side_drawer_French_door", //"در فرانسوی",
          icon: FrenchRightDoubleDoor,
          key: "F_RIGHT_UP_D",
          type: "door",
          name2: "FaransaviChefti",
          name: "FaransaviTowHalateh",
        },
        {
          title: "tool_side_drawer_French_door", //"در فرانسوی",
          icon: FrenchLeftDoubleDoor,
          key: "F_LEFT_UP_D",
          type: "door",
          name2: "FaransaviChefti",
          name: "FaransaviTowHalateh",
        },
      ],
    },
  ],
  foldSlide: [
    {
      title: "tool_side_drawer_Accordion", //" آکاردئونی",
      icon: ak_2_0,
      type: "foldSlide",
      auth: [0],
    },
  ],
  drawer: [
    {
      title: "tool_side_drawer_Single_2s", //"کشویی تک ریل دو لنگه",
      auth: [1, 3],
      disabled: ["Id_molion_1rail"],
      sub: [
        {
          title: "tool_side_drawer_Single_2s", //"کشویی تک ریل دو لنگه",
          icon: RightDrawerSingleRailTwo,
          key: "LENGEH_RAIL_1_F_RIGHT_B_FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Single_2s", //"کشویی تک ریل دو لنگه",
          icon: LeftDrawerSingleRailTwo,
          key: "LENGEH_RAIL_1_B_FIX_F_LEFT",
          type: "drawer",
        },
      ],
    },
    {
      title: "tool_side_drawer_Single_3s", //"کشویی تک ریل سه لنگه",
      auth: [1, 3],
      disabled: ["Id_molion_1rail"],
      sub: [
        {
          title: "tool_side_drawer_Single_3s", //"کشویی تک ریل سه لنگه",
          icon: LeftDrawerSingleRailThree,
          key: "LENGEH_RAIL_1_B_FIX_B_FIX_F_LEFT",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Single_3s", //"کشویی تک ریل سه لنگه",
          icon: RightDrawerSingleRailThree,
          key: "LENGEH_RAIL_1_F_RIFGT_B_FIX_B_FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Single_3s", //"کشویی تک ریل سه لنگه",
          icon: LeftDrawerSingleRailThreeLeaf,
          key: "LENGEH_RAIL_1_B_FIX_F_LEFT_B_FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Single_3s", //"کشویی تک ریل سه لنگه",
          icon: RightDrawerSingleRailThreeLeaf,
          key: "LENGEH_RAIL_1_B_FIX_F_RIGHT_B_FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Single_3s", //"کشویی تک ریل سه لنگه",
          icon: RightAndLeftDrawerSingleRailThreeLeaf,
          key: "LENGEH_RAIL_1_F_RIGHT_B_FIX_F_LEFT",
          type: "drawer",
        },
      ],
    },
    {
      title: "tool_side_drawer_Single_4s", //"کشویی تک ریل چهار لنگه",
      auth: [1, 3],
      disabled: ["Id_molion_1rail"],
      sub: [
        {
          title: "tool_side_drawer_Single_4s", //"کشویی تک ریل چهار لنگه",
          icon: RightAndLeftDrawerSingleRailFourLeaf,
          key: "LENGEH_RAIL_1_F_RIGHT_B_FIX_B_FIX_F_LEFT",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Single_4s", //"کشویی تک ریل چهار لنگه",
          icon: LeftAndRightDrawerSingleRailFourLeaf,
          key: "LENGEH_RAIL_1_B_FIX_F_LEFT_F_RIGHT_B_FIX",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Single_4s", //"کشویی تک ریل چهار لنگه",
          icon: LeftDrawerSingleRailFourLeaf,
          key: "LENGEH_RAIL_1_B_FIX_B_FIX_B_FIX_F_LEFT",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Single_4s", //"کشویی تک ریل چهار لنگه",
          icon: RightDrawerSingleRailFourLeaf,
          key: "LENGEH_RAIL_1_F_RIGHT_B_FIX_B_FIX_B_FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Single_4s", //"کشویی تک چهار سه لنگه",
          icon: LeftDrawerSingleRailFour,
          key: "LENGEH_RAIL_1_B_FIX_F_LEFT_B_FIX_B_FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Single_4s", //"کشویی تک ریل چهار لنگه",
          icon: RightDrawerSingleRailFour,
          key: "LENGEH_RAIL_1_B_FIX_B_FIX_F_RIGHT_B_FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Single_4s", //"کشویی تک ریل چهار لنگه",
          icon: LeftDrawerFourLeatSingleRail,
          key: "LENGEH_RAIL_1_B_FIX_B_FIX_F_LEFT_B_FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Single_4s", //"کشویی تک ریل چهار لنگه",
          icon: RightDrawerFourLeatSingleRail,
          key: "LENGEH_RAIL_1_B_FIX_F_RIGHT_B_FIX_B_FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Single_4s", //"کشویی تک ریل چهار لنگه",
          icon: RightAndRightDrawerSingleRailFourLeat,
          key: "LENGEH_RAIL_1_F_RIGHT_B_FIX_F_RIGHT_B_FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Single_4s", //"کشویی تک ریل چهار لنگه",
          icon: LeftAndLeftDrawerSingleRailFourLeat,
          key: "LENGEH_RAIL_1_B_FIX_F_LEFT_B_FIX_F_LEFT",
          type: "drawer",
        },
      ],
    },
    {
      title: "tool_side_drawer_Double_2s", //"کشویی جفت ریل دو لنگه",
      auth: [2, 4],
      sub: [
        {
          title: "tool_side_drawer_Double_2s", //"کشویی جفت ریل دو لنگه",
          icon: RightAndLeftDrawerTwoRailTwoLeat,
          key: "LENGEH_RAIL_2_F_RIGHT_B_LEFT",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Double_2s", //"کشویی جفت ریل دو لنگه",
          icon: LeftDrawerTwoRailTwoLeat,
          key: "LENGEH_RAIL_2_B_FIX_F_LEFT",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Double_2s", //"کشویی جفت ریل دو لنگه",
          icon: RightDrawerTwoRailTwoLeat,
          key: "LENGEH_RAIL_2_F_RIGHT_B_FIX",
          type: "drawer",
        },
      ],
    },
    {
      title: "tool_side_drawer_Double_3s", //"کشویی جفت ریل سه لنگه",
      auth: [2, 4],
      sub: [
        {
          title: "tool_side_drawer_Double_3s", //"کشویی جفت ریل سه لنگه",
          icon: RightDrawerTwoRailThree,
          key: "LENGEH_RAIL_2_F_RIGHT_B_FIX_F_FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Double_3s", //"کشویی جفت ریل سه لنگه",
          icon: LeftDrawerTwoRailThree,
          key: "LENGEH_RAIL_2_F_FIX_B_FIX_F_LEFT",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Double_3s", //"کشویی جفت ریل سه لنگه",
          icon: RightDrawerTwoRailThreeLeat,
          key: "LENGEH_RAIL_2_B_FIX_F_RIGHT_B_FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Double_3s", //"کشویی جفت ریل سه لنگه",
          icon: LeftDrawerTwoRailThreeLeat,
          key: "LENGEH_RAIL_2_B_FIX_F_LEFT_B_FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Double_3s", //"کشویی جفت ریل سه لنگه",
          icon: RightDrawerThreeLeatTwoRail,
          key: "LENGEH_RAIL_2_F_FIX_F_RIGHT_B_FIX",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Double_3s", //"کشویی جفت ریل سه لنگه",
          icon: LeftDrawerThreeLeatTwoRail,
          key: "LENGEH_RAIL_2_B_FIX_F_LEFT_F_FIX",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Double_3s", //"کشویی جفت ریل سه لنگه",
          icon: RightDrawerThreeLeatTwoRails,
          key: "LENGEH_RAIL_2_F_RIGHT_B_FIX_B_FIX",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Double_3s", //"کشویی جفت ریل سه لنگه",
          icon: DrawerThreeLeatTwoRail,
          key: "LENGEH_RAIL_2_B_FIX_B_FIX_F_LEFT",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Double_3s", //"کشویی جفت ریل سه لنگه",
          icon: RightAndLeftDrawerThreeLeatTwoRail,
          key: "LENGEH_RAIL_2_B_RIGHT_F_LEFT_F_FIX",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Double_3s", //"کشویی جفت ریل سه لنگه",
          icon: RightAndLeftDrawerTwoRailThreeLeat,
          key: "LENGEH_RAIL_2_F_FIX_F_RIGHT_B_LEFT",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Double_3s", //"کشویی جفت ریل سه لنگه",
          icon: RightAndRightLeftDrawerTwoRailThreeLeat,
          key: "LENGEH_RAIL_2_B_RIGHT_F_RIGHT_B_LEFT",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Double_3s", //"کشویی جفت ریل سه لنگه",
          icon: RightAndLeftLeftDrawerTwoRailThreeLeat,
          key: "LENGEH_RAIL_2_B_RIGHT_F_LEFT_B_LEFT",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Double_3s", //"کشویی جفت ریل سه لنگه",
          icon: RightLeftDrawerTwoRailThreeLeat,
          key: "LENGEH_RAIL_2_F_RIGHT_B_FIX_F_LEFT",
          type: "drawer",
        },
      ],
    },
    {
      title: "tool_side_drawer_Double_4s", //"کشویی جفت ریل چهار لنگه",
      auth: [2, 4],
      sub: [
        {
          title: "tool_side_drawer_Double_4s", //"کشویی جفت ریل چهار لنگه",
          icon: RightAndLeftDrawerTwoRailFourLeat,
          key: "LENGEH_RAIL_2_F_RIGHT_B_FIX_B_FIX_F_LEFT",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Double_4s", //"کشویی جفت ریل چهار لنگه",
          icon: LeftAndRightDrawerTwoRailFourLeat,
          key: "LENGEH_RAIL_2_B_FIX_F_LEFT_F_RIGHT_B_FIX",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Double_4s", //"کشویی جفت ریل چهار لنگه",
          icon: RightDrawerTwoRailFourLeat,
          key: "LENGEH_RAIL_2_F_FIX_F_RIGHT_B_FIX_B_FIX",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Double_4s", //"کشویی جفت ریل چهار لنگه",
          icon: LeftDrawerTwoRailFourLeat,
          key: "LENGEH_RAIL_2_B_FIX_B_FIX_F_LEFT_F_FIX",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Double_4s", //"کشویی جفت چهار سه لنگه",
          icon: RightDrawerFourLeatTwoRail,
          key: "LENGEH_RAIL_2_F_RIGHT_B_FIX_B_FIX_B_FIX",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Double_4s", //"کشویی جفت ریل چهار لنگه",
          icon: LeftAndLeftDrawerTwoRailFourLeat,
          key: "LENGEH_RAIL_2_B_FIX_F_LEFT_B_FIX_F_LEFT",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Double_4s", //"کشویی جفت ریل چهار لنگه",
          icon: RightAndLeftDrawerTwoRailFour,
          key: "LENGEH_RAIL_2_B_RIGHT_F_FIX_B_FIX_F_LEFT",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Double_4s", //"کشویی جفت ریل چهار لنگه",
          icon: RightAndLeftDrawerFourLeatTwoRail,
          key: "LENGEH_RAIL_2_F_FIX_F_RIGHT_B_LEFT_B_FIX",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Double_4s", //"کشویی جفت ریل چهار لنگه",
          icon: RightAndLeftRightDrawerTwoRailFourLeat,
          key: "LENGEH_RAIL_2_B_RIGHT_F_LEFT_F_RIGHT_B_LEFT",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Double_4s", //"کشویی جفت ریل چهار لنگه",
          icon: LeftDrawerTwoRailFour,
          key: "LENGEH_RAIL_2_B_FIX_B_FIX_B_FIX_F_LEFT",
          type: "drawer",
          disabled: ["Id_conector_sash"],
        },
        {
          title: "tool_side_drawer_Double_4s", //"کشویی جفت ریل چهار لنگه",
          icon: RightAndRightDrawerTwoRailFourLeat,
          key: "LENGEH_RAIL_2_F_RIGHT_B_FIX_F_RIGHT_B_FIX",
          type: "drawer",
        },
      ],
    },
    {
      title: "tool_side_drawer_Triple_3s", //"کشویی سه ریل سه لنگه",
      auth: [5, 7],
      sub: [
        {
          title: "tool_side_drawer_Triple_3s", //"کشویی سه ریل سه لنگه",
          icon: LENGEH_RAIL_3_1RIGHT_2RIGHT_3FIX,
          key: "LENGEH_RAIL_3_1RIGHT_2RIGHT_3FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Triple_3s", //"کشویی سه ریل سه لنگه",
          icon: LENGEH_RAIL_3_3RIGHT_2RIGHT_1LEFT,
          key: "LENGEH_RAIL_3_3RIGHT_2RIGHT_1LEFT",
          type: "drawer",
        },
      ],
    },
    {
      title: "tool_side_drawer_Triple_5s", //"کشویی سه ریل پنج لنگه",
      auth: [5, 7],
      sub: [
        {
          title: "tool_side_drawer_Triple_5s", //"کشویی سه ریل پنج لنگه",
          icon: LENGEH_RAIL_3_1FIX_2LEFT_3RIGHT_3RIGHT_2FIX,
          key: "LENGEH_RAIL_3_1FIX_2LEFT_3RIGHT_3RIGHT_2FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Triple_5s", //"کشویی سه ریل پنج لنگه",
          icon: LENGEH_RAIL_3_1RIGHT_2LEFT_3RIGHT_3RIGHT_2LEFT,
          key: "LENGEH_RAIL_3_1RIGHT_2LEFT_3RIGHT_3RIGHT_2LEFT",
          type: "drawer",
        },
      ],
    },
    {
      title: "tool_side_drawer_Triple_6s", //"کشویی سه ریل شش لنگه",
      auth: [5, 7],
      sub: [
        {
          title: "tool_side_drawer_Triple_6s", //"کشویی سه ریل شش لنگه",
          icon: LENGEH_RAIL_3_1FIX_2LEFT_3LEFT_3RIGHT_2RIGHT_1FIX,
          key: "LENGEH_RAIL_3_1FIX_2LEFT_3LEFT_3RIGHT_2RIGHT_1FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Triple_6s", //"کشویی سه ریل شش لنگه",
          icon: LENGEH_RAIL_3_3FIX_2LEFT_1LEFT_1RIGHT_2RIGHT_3FIX,
          key: "LENGEH_RAIL_3_3FIX_2LEFT_1LEFT_1RIGHT_2RIGHT_3FIX",
          type: "drawer",
        },
      ],
    },
    {
      title: "tool_side_drawer_Quad_4s", //"کشویی چهار ریل چهار لنگه",
      auth: [6, 8],
      sub: [
        {
          title: "tool_side_drawer_Quad_4s", //"کشویی چهار ریل چهار لنگه",
          icon: LENGEH_RAIL_4_1FIX_2LEFT_3LEFT_4LEFT,
          key: "LENGEH_RAIL_4_1FIX_2LEFT_3LEFT_4LEFT",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Quad_4s", //"کشویی چهار ریل چهار لنگه",
          icon: LENGEH_RAIL_4_1RIGHT_2RIGHT_3RIGHT_4FIX,
          key: "LENGEH_RAIL_4_1RIGHT_2RIGHT_3RIGHT_4FIX",
          type: "drawer",
        },
      ],
    },
    {
      title: "tool_side_drawer_Quad_6s", //"کشویی چهار ریل شش لنگه",
      auth: [6, 8],
      sub: [
        {
          title: "tool_side_drawer_Quad_6s", //"کشویی چهار ریل شش لنگه",
          icon: LENGEH_RAIL_4_2FIX_1LEFT_1RIGHT_2RIGHT_3RIGHT_4FIX,
          key: "LENGEH_RAIL_4_2FIX_1LEFT_1RIGHT_2RIGHT_3RIGHT_4FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Quad_6s", //"کشویی چهار ریل شش لنگه",
          icon: LENGEH_RAIL_4_4FIX_3LEFT_2LEFT_1LEFT_1RIGHT_2FIX,
          key: "LENGEH_RAIL_4_4FIX_3LEFT_2LEFT_1LEFT_1RIGHT_2FIX",
          type: "drawer",
        },
      ],
    },
    {
      title: "tool_side_drawer_Quad_7s", //"کشویی چهار ریل هفت لنگه",
      auth: [6, 8],
      sub: [
        {
          title: "tool_side_drawer_Quad_7s", //"کشویی چهار ریل هفت لنگه",
          icon: LENGEH_RAIL_4_3FIX_2LEFT_1LEFT_1RIGHT_2RIGHT_3RIGHT_4FIX,
          key: "LENGEH_RAIL_4_3FIX_2LEFT_1LEFT_1RIGHT_2RIGHT_3RIGHT_4FIX",
          type: "drawer",
        },
        {
          title: "tool_side_drawer_Quad_7s", //"کشویی چهار ریل هفت لنگه",
          icon: LENGEH_RAIL_4_4FIX_3LEFT_2LEFT_1LEFT_1RIGHT_2RIGHT_3FIX,
          key: "LENGEH_RAIL_4_4FIX_3LEFT_2LEFT_1LEFT_1RIGHT_2RIGHT_3FIX",
          type: "drawer",
        },
      ],
    },
    {
      title: "tool_side_drawer_Quad_8s", //"کشویی چهار ریل هشت لنگه",
      icon: LENGEH_RAIL_4_4FIX_3LEFT_2LEFT_1LEFT_1RIGHT_2RIGHT_3RIGHT_4FIX,
      key: "LENGEH_RAIL_4_4FIX_3LEFT_2LEFT_1LEFT_1RIGHT_2RIGHT_3RIGHT_4FIX",
      type: "drawer",
      auth: [6, 8],
    },
  ],
  other: [
    {
      title: "tool_side_drawer_sash_net", //"توری و لنگه فیکس",
      auth: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      sub: [
        {
          title: "tool_side_drawer_Net", //"توری ",
          icon: Net,
          key: "NET",
          type: "other",
        },
        {
          title: "tool_side_drawer_FixedSash", //"لنگه فیکس",
          icon: Fix,
          key: "FIX_SASH",
          type: "other",
          disabled: ["Sys_tak_joft"],
        },
      ],
    },
    {
      title: "tool_side_drawer_Panel", //"پانل",
      auth: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      disabled: ["Id_panel2"],
      sub: [
        {
          title: "tool_side_drawer_Panel", //"پانل ",
          icon: VerticalPanel,
          key: "V_PANEL",
          type: "other",
        },
        {
          title: "tool_side_drawer_Panel", //" پانل",
          icon: HorizontalPanel,
          key: "H_PANEL",
          type: "other",
        },
      ],
    },
  ],
  addons: [
    {
      title: "tool_side_drawer_Beading", //"روکوب،آستانه،پاخور و ارتفاع دهنده",
      icon: Flashing,
      type: "addons",
      auth: [0, 1, 2, 3, 4, 5, 6, 7, 8],
    },
  ],
};
